var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNegotiationInfo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.9 20.3L26.1 20.3L26.1 14.5L31.9 14.5L31.9 20.3ZM31.9 43.5L26.1 43.5L26.1 26.1L31.9 26.1L31.9 43.5ZM29.029 58C45.037 58 58 45.008 58 29C58 12.992 45.037 2.68144e-06 29.029 1.28197e-06C12.992 -1.20027e-07 3.93472e-06 12.992 2.53526e-06 29C1.1358e-06 45.008 12.992 58 29.029 58ZM29 5.8C41.818 5.8 52.2 16.182 52.2 29C52.2 41.818 41.818 52.2 29 52.2C16.182 52.2 5.8 41.818 5.8 29C5.8 16.182 16.182 5.8 29 5.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegotiationInfo);
export default __webpack_public_path__ + "static/media/negotiation-info.0d3a3340.svg";
export { ForwardRef as ReactComponent };